module.exports = __webpack_public_path__ + "img/cimb.e320ed6b.png";